import { trans } from "@mongez/localization";
import type { Page } from "core/informative-pages";
import { URLS } from "framework/config/urls";
import breadcrumbsImage from "~/assets/images/info-pages/terms-and-conditions-breadcrumb.png";
import { Breadcrumbs } from "~/design-system/components/breadcrumbs";
import { HTML } from "~/modules/shared/components";
import { getLocalizedValue } from "~/shared/urils/getLocalizedValue";

export function PageContent({ page }: { page: Page }) {
  // Page content is localized: the API returns plain strings for the requested
  // locale and falls back to a localized array when it has no translation.
  const title = String(getLocalizedValue(page?.title) || "");
  const description = String(getLocalizedValue(page?.description) || "");

  return (
    <section className="bg-[#F9F9F9]">
      <Breadcrumbs
        title={title}
        image={breadcrumbsImage}
        items={[
          {
            text: trans("home"),
            href: URLS.home,
          },
          {
            text: trans(title),
            href: URLS[page.name],
          },
        ]}
      />
      <div className="prose prose-p:text-black/90 prose-strong:font-bold prose-strong:text-primary-default prose-a:text-primary-default prose-a:hover:text-primary-default/70 prose-a:transition-colors prose-a:hover:underline container max-w-[1920px] py-9 transition-colors duration-300">
        <HTML html={description} />
      </div>
    </section>
  );
}
